import React from 'react'

const Jva_Bd = () => {
    return (
        <div className='container'>
            <h1 class="h1">Java Convert Decimal to Binary</h1>

<p>We can convert <strong>decimal to binary in java</strong> using <em>Integer.toBinaryString()</em> method or custom
   logic.</p>

<h2 class="h2">Java Decimal to Binary conversion: Integer.toBinaryString()</h2>
<p>The Integer.toBinaryString() method converts decimal to binary string. <br /> The <strong>signature</strong> of
   toBinaryString() method is given below:</p>

<div class="containers">
   <div class="dp-highlighter">
      
        
      <ol start="1" class="dp-j">
         <li class="alt"><span><span class="keywords">public</span><span>&nbsp;</span><span
                  class="keywords">static</span><span>&nbsp;String&nbsp;toBinaryString(</span><span
                  class="keywords">int</span><span>&nbsp;decimal)&nbsp;&nbsp;</span></span></li>
      </ol>
   </div>
</div>

<p>Let's see the simple example of converting decimal to binary in java.</p>
<div class="containers">
   
      
        
      <ol start="1" class="dp-j">
         <li class="alt"><span><span class="keywords">public</span><span>&nbsp;</span><span
                  class="keywords">class</span><span>&nbsp;DecimalToBinaryExample1&#123;&nbsp;&nbsp;</span></span></li>
         <li class=""><span><span class="keywords">public</span><span>&nbsp;</span><span
                  class="keywords">static</span><span>&nbsp;</span><span
                  class="keywords">void</span><span>&nbsp;main(String&nbsp;args[])&#123;&nbsp;&nbsp;</span></span></li>
         <li class="alt"><span>System.out.println(Integer.toBinaryString(<span
                  class="plain">10</span><span>));&nbsp;&nbsp;</span></span></li>
         <li class=""><span>System.out.println(Integer.toBinaryString(<span
                  class="plain">21</span><span>));&nbsp;&nbsp;</span></span></li>
         <li class="alt"><span>System.out.println(Integer.toBinaryString(<span
                  class="plain">31</span><span>));&nbsp;&nbsp;</span></span></li>
         <li class=""><span>&#125;&nbsp;&nbsp;</span></li>
      </ol>
   </div>

   <p>Output:</p>
   <div class="output">
      <pre>1010 <br/>
   10101 <br/>
   11111 <br/>
   </pre>
   </div>


   <h2 class="h2">Java Decimal to Binary conversion: Custom Logic</h2>
   <p>We can convert <strong>decimal to binary in java</strong> using custom logic.</p>

   <div class="containers">
      <div class="dp-highlighter">
         
          
         <ol start="1" class="dp-j">
            <li class="alt"><span><span class="keywords">public</span><span>&nbsp;</span><span
                     class="keywords">class</span><span>&nbsp;DecimalToBinaryExample2&#123;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
            </li>
            <li class=""><span><span class="keywords">public</span><span>&nbsp;</span><span
                     class="keywords">static</span><span>&nbsp;</span><span
                     class="keywords">void</span><span>&nbsp;toBinary(</span><span
                     class="keywords">int</span><span>&nbsp;decimal)&#123;&nbsp;&nbsp;&nbsp;&nbsp;</span></span></li>
            <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                     class="keywords">int</span><span>&nbsp;binary[]&nbsp;=&nbsp;</span><span
                     class="keywords">new</span><span>&nbsp;</span><span class="keywords">int</span><span>[</span><span
                     class="plain">40</span><span>];&nbsp;&nbsp;&nbsp;&nbsp;</span></span></li>
            <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                     class="keywords">int</span><span>&nbsp;index&nbsp;=&nbsp;</span><span
                     class="plain">0</span><span>;&nbsp;&nbsp;&nbsp;&nbsp;</span></span></li>
            <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                     class="keywords">while</span><span>(decimal&nbsp;&gt;&nbsp;</span><span
                     class="plain">0</span><span>)&#123;&nbsp;&nbsp;&nbsp;&nbsp;</span></span></li>
            <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;binary[index++]&nbsp;=&nbsp;decimal%<span
                     class="plain">2</span><span>;&nbsp;&nbsp;&nbsp;&nbsp;</span></span></li>
            <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;decimal&nbsp;=&nbsp;decimal/<span
                     class="plain">2</span><span>;&nbsp;&nbsp;&nbsp;&nbsp;</span></span></li>
            <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
            <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="keywords">for</span><span>(</span><span
                     class="keywords">int</span><span>&nbsp;i&nbsp;=&nbsp;index-</span><span
                     class="plain">1</span><span>;i&nbsp;&gt;=&nbsp;</span><span
                     class="plain">0</span><span>;i--)&#123;&nbsp;&nbsp;&nbsp;&nbsp;</span></span></li>
            <li class="">
               <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.print(binary[i]);&nbsp;&nbsp;&nbsp;&nbsp;</span>
            </li>
            <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
            <li class=""><span>System.out.println();<span
                     class="comment">//new&nbsp;line</span><span>&nbsp;&nbsp;</span></span></li>
            <li class="alt"><span>&#125;&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
            <li class=""><span><span class="keywords">public</span><span>&nbsp;</span><span
                     class="keywords">static</span><span>&nbsp;</span><span
                     class="keywords">void</span><span>&nbsp;main(String&nbsp;args[])&#123;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
            </li>
            <li class="alt"><span>System.out.println(<span
                     class="string">"Decimal&nbsp;of&nbsp;10&nbsp;is:&nbsp;"</span><span>);&nbsp;&nbsp;</span></span>
            </li>
            <li class=""><span>toBinary(<span class="plain">10</span><span>);&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
            </li>
            <li class="alt"><span>System.out.println(<span
                     class="string">"Decimal&nbsp;of&nbsp;21&nbsp;is:&nbsp;"</span><span>);&nbsp;&nbsp;</span></span>
            </li>
            <li class=""><span>toBinary(<span class="plain">21</span><span>);&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
            </li>
            <li class="alt"><span>System.out.println(<span
                     class="string">"Decimal&nbsp;of&nbsp;31&nbsp;is:&nbsp;"</span><span>);&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
            </li>
            <li class=""><span>toBinary(<span class="plain">31</span><span>);&nbsp;&nbsp;</span></span></li>
            <li class="alt"><span>&#125;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
         </ol>
      </div>
   </div>

   <p>Output:</p>
   <div class="output">
      <pre>Decimal of 10 is:  <br/>
   1010 <br/>
   Decimal of 21 is:  <br/>
   10101 <br/>
   Decimal of 31 is:  <br/>
   11111 <br/>
   </pre>
   </div>
        </div>
    )
}

export default Jva_Bd
